import * as React from "react";
import { callApi } from "../../utils/api";
import { ADMIN_ROLE } from "../../utils/role";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import moment from "moment";
import isEmpty from 'lodash/isEmpty';
import Accordion from "react-bootstrap/Accordion";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Select from 'react-select';
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;
export interface DeviationTake {
    id: number;
    name: string;
}
interface AllProps {
    history: any;
}
class DeviationTakeManage extends React.Component<AllProps> {
    state = {
        categorys: [],
        categoryToBeDeleted: "",
        isFileRefresh: false,
        selectedcategory: {
            id: 0,
            category_value: "",
        },
        outreason: "",
        selectVal: false,
        isLoading: false,
        activeTabKey: 'deviationRequestedBy',
    };
    async componentDidMount() {
        this.categoryGet(this.state.activeTabKey);
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
    }

    categoryGet = (key) => {
        this.setState({ isFileRefresh: false });
        const api = "deviation_take_get.php";
        callApi("POST", api, { category_type: key })
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                if (files && files.length > 0) {
                    files.forEach((file, index) => {
                        Object.keys(file).forEach(fileKey => {
                            file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== 'string' ? String(file[fileKey]) : file[fileKey];
                        })
                        file.index = index + 1;
                    })
                }
                this.setState({ categorys: files, isFileRefresh: true });
            })
            .catch(err => {
                console.log(err);
            });
    };
    addDeviationTake = () => {
        this.setState({ selectedcategory: Object.assign({}) });
    };
    addMapCategory = () => {
        this.setState({ selectedMapCategory: Object.assign({}) });
    };
    editDeviationTake = (deviationTake: DeviationTake) => {
        this.setState({ selectedcategory: deviationTake });
    };
    editMapCategory = (deviationTake: DeviationTake) => {
        this.setState({ selectedMapCategory: deviationTake });
    };
    saveDeviationTake = () => {
        const { activeTabKey } = this.state;
        const enteredValue = (this.state.selectedcategory.category_value || "").trim();
        const editingId = this.state.selectedcategory.id;
        const isDuplicate = (this.state.categorys || []).some((c: any) =>
            String(c.id) !== String(editingId) &&
            (c.category_value || "").trim().toLowerCase() === enteredValue.toLowerCase()
        );
        if (enteredValue && isDuplicate) {
            ToastsStore.error("This value already exists.");
            return;
        }
        const api = !isEmpty(this.state.selectedcategory.id) ? "deviation_take_update.php" : "deviation_take_create.php";
        const payload = {
            id: Number(this.state.selectedcategory.id),
            category_type: activeTabKey,
            category_value: this.state.selectedcategory.category_value
        }
        callApi("POST", api, payload)
            .then(res => res.data)
            .then(response => {
                if (response.success) {
                    $("#category-form").modal("hide");
                    ToastsStore.success(response.message);
                    this.categoryGet(activeTabKey);
                    this.setState({ selectedcategory: {} });
                } else {
                    ToastsStore.error(response.message);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    confirmDeleteDeviationTake = (modal: DeviationTake) => {
        this.setState({ categoryToBeDeleted: modal.id });
    };

    deleteDeviationTake = () => {
        const { activeTabKey } = this.state;
        const api = "deviation_take_delete.php";

        callApi("POST", api, { id: this.state.categoryToBeDeleted, category_type: activeTabKey })
            .then(res => res.data)
            .then(response => {
                if (response.success) {
                    ToastsStore.success(response.message);
                    this.categoryGet(activeTabKey);
                } else {
                    ToastsStore.error(response.message);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    handleChange = (e: any) => {
        const deviationTakedetail: any = this.state.selectedcategory;
        deviationTakedetail[e.target.name] = e.target.value;
        this.setState({ deviationTakedetail });
    };
    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    }
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    }
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime))
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
        else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }

    }
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    }
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        }
        else {
            let obj = {
                "file_id": JSON.parse(fileid1),
                "user_id": JSON.parse(userid1),
                "in_reason": JSON.parse(inreason),
                "out_reason": this.state.outreason,
                "intime": JSON.parse(intime),
                "outtime": JSON.parse(outtime),
                "insert_date": JSON.parse(outdate),
                "total_seconds": secondsSpent,
                "insert_id": insertId
            }

            callApi("POST", "process_eod_insert.php", obj)
                .then(res => res.data)
                .then(response => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    localStorage.removeItem('currentfileId');
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                }).catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                })
        }
    }

    onchangeReason = (e: any) => {

        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false })
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        }
        else if (e.target.value == "select") {
            this.setState({ setResponse: false })
        }
        else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
    };

    headerTitleDisplay = (status) => {
        switch (status) {
            case 'deviationRequestedBy':
                return 'Requested By';
            case 'deviationRequestReason':
                return 'Request Reason';
            case 'doubtLocation':
                return 'Doubt Location';
            case 'deviationSummary':
                return 'Deviation Summary'; // fixed typo
            case 'trainingToWhom':
                return 'Training To Whom';
            case 'trainingArea':
                return 'Training Area';
            default:
                return 'Value';
        }
    }

    render() {
        const user: any = localStorage.getItem("user");
        const role_id = user ? JSON.parse(user)["role_id"] : "";
        const { activeTabKey }: any = this.state;
        const columns = [
            {
                header: 'ID',
                key: 'index',
            },
            {
                header: this.headerTitleDisplay(activeTabKey),
                key: 'category_value',
            },
            {
                header: "Actions",
                td: (file) => {
                    return <div className="btn-group mb-2 mr-2">
                        <button
                            type="button"
                            className="btn btn-primary"
                        >
                            Action
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="sr-only">
                                Toggle Dropdown
                            </span>
                        </button>
                        <div
                            className="dropdown-menu"
                            x-placement="top-start"
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                transform:
                                    "translate3d(88px, -2px, 0px)"
                            }}
                        >
                            <a
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target="#category-form"
                                onClick={() =>
                                    this.editDeviationTake(file)
                                }
                            >
                                Edit
                            </a>
                            {role_id === ADMIN_ROLE && (
                                <a
                                    className="dropdown-item"
                                    style={{ float: "right" }}
                                    data-toggle="modal"
                                    data-target="#delete-deviationTake"
                                    onClick={() =>
                                        this.confirmDeleteDeviationTake(file)
                                    }
                                >
                                    Delete
                                </a>
                            )}
                        </div>
                    </div>
                }
            }
        ];
        const data = this.state.categorys;
        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />{" "}
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Deviation Take Management</h5>
                                                    <button
                                                        className="btn btn-primary"
                                                        style={{ float: "right" }}
                                                        onClick={() => this.props.history.goBack()}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <Accordion className="mainAccordion">
                                                        <Tabs
                                                            defaultActiveKey="deviationRequestedBy"
                                                            onSelect={(key) => {
                                                                this.setState({ activeTabKey: key });
                                                                this.categoryGet(key);
                                                            }}
                                                        >
                                                            <Tab
                                                                eventKey="deviationRequestedBy"
                                                                title="Deviation Requested by"
                                                                key={`deviationRequestedBy`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addDeviationTake}
                                                                    >
                                                                        + Add
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>
                                                            <Tab
                                                                eventKey="deviationRequestReason"
                                                                title="Deviation Request Reason"
                                                                key={`deviationRequestReason`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addDeviationTake}
                                                                    >
                                                                        + Add
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>
                                                            <Tab
                                                                eventKey="doubtLocation"
                                                                title="Doubt Location"
                                                                key={`doubtLocation`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addDeviationTake}
                                                                    >
                                                                        + Add
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>

                                                            <Tab
                                                                eventKey="deviationSummary"
                                                                title="Deviation Summary"
                                                                key={`deviationSummary`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addMapCategory}
                                                                    >
                                                                        + Add
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>

                                                            <Tab
                                                                eventKey="trainingToWhom"
                                                                title="Traing to whom"
                                                                key={`trainingToWhom`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addMapCategory}
                                                                    >
                                                                        + Add
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>

                                                            <Tab
                                                                eventKey="trainingArea"
                                                                title="Training Area"
                                                                key={`trainingArea`}
                                                            >
                                                                <div className="dt-responsive table-responsive">
                                                                    <a
                                                                        className="btn btn-primary m-b-20"
                                                                        data-toggle="modal"
                                                                        data-target="#category-form"
                                                                        onClick={this.addMapCategory}
                                                                    >
                                                                        + Add
                                                                    </a>

                                                                    {this.state.isFileRefresh && data.length > 0 &&
                                                                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                    }
                                                                </div>
                                                            </Tab>
                                                        </Tabs>
                                                    </Accordion>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="category-form"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="col-form-label">Enter the Value:</label>{" "}
                                                <input
                                                    type="text"
                                                    name="category_value"
                                                    className="form-control"
                                                    placeholder=""
                                                    onChange={e => {
                                                        this.handleChange(e);
                                                    }}
                                                    value={
                                                        this.state.selectedcategory.category_value
                                                            ? this.state.selectedcategory.category_value
                                                            : ""
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.saveDeviationTake}
                                >
                                    {isEmpty(this.state.selectedcategory.id) ? "Save" : "Update"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="delete-deviationTake"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>Are you sure you want to delete this?</h6>
                                <div className="form-group">
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    onClick={this.deleteDeviationTake}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* THIS FOR OUT REASON MODAL */}
                <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                            </div>
                            <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: '8px' }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>

                                </select>
                                {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: '27px' }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: '76px', fontSize: '17px' }}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                                > Back To File</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OTHER REASON MODAL */}
                <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason" onChange={this.onchange} />
                                    {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: '76px', fontSize: '17px' }}
                                    disabled={this.state.isLoading}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"

                                    onClick={() => this.previousPop()}
                                    style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                                > Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default DeviationTakeManage;
